import type { CSSProperties } from 'react'
import { designTokens } from '@/shared/lib/design-tokens'

type LogoProps = {
  style?: CSSProperties
  className?: string
  width?: number | string
  height?: number | string
}

export function CloudPaymentLogo({ style, className, width, height }: LogoProps) {
  return (
    <svg
      width={width ?? designTokens.sizes.width.paymentMethodLogoCloud}
      height={height ?? designTokens.sizes.height.paymentMethodLogoCloud}
      viewBox="0 0 88 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <g clipPath="url(#clip0_80_1273)">
        <path
          d="M3.82617 2.10608H6.11124C6.31897 2.10608 6.94217 2.03584 7.21915 3.01912C7.42688 3.65122 7.70386 4.63449 8.11933 6.10939H8.25781C8.67328 4.56425 9.0195 3.51075 9.15799 3.01912C9.43497 2.03584 10.1274 2.10608 10.4044 2.10608H12.551V8.84851H10.3351V4.84519H10.1967L9.0195 8.84851H7.35764L6.18048 4.84519H5.97275V8.84851H3.82617M13.4511 2.10608H15.667V6.10939H15.8747L17.3288 2.80841C17.6058 2.17631 18.229 2.10608 18.229 2.10608H20.3063V8.84851H18.0905V4.84519H17.952L16.4979 8.14617C16.2209 8.77827 15.5285 8.84851 15.5285 8.84851H13.4511M23.2839 6.81173V8.84851H21.2065V5.33682H27.9925C27.7155 6.17963 26.7461 6.81173 25.6382 6.81173"
          fill="#0F754E"
        />
        <path
          d="M28.1313 4.9153C28.4083 3.6511 27.5773 2.10596 25.777 2.10596H21.0684C21.2068 3.58086 22.4532 4.9153 23.7689 4.9153"
          fill="url(#paint0_linear_80_1273)"
        />
      </g>
      <g clipPath="url(#clip1_80_1273)">
        <path
          d="M51.1536 1.68994C49.5401 1.68994 48.0981 2.53461 48.0981 4.09484C48.0981 5.88434 50.6554 6.00792 50.6554 6.90703C50.6554 7.28561 50.2259 7.62444 49.4921 7.62444C48.4509 7.62444 47.6727 7.15099 47.6727 7.15099L47.3396 8.7257C47.3396 8.7257 48.2362 9.12564 49.4263 9.12564C51.1905 9.12564 52.5788 8.23962 52.5788 6.65251C52.5788 4.76148 50.0107 4.64157 50.0107 3.80724C50.0107 3.51067 50.3633 3.18586 51.0949 3.18586C51.9205 3.18586 52.5938 3.5302 52.5938 3.5302L52.9198 2.00948C52.9198 2.00948 52.1868 1.68994 51.1534 1.68994H51.1536ZM36.3907 1.8048L36.3516 2.03429C36.3516 2.03429 37.0304 2.15971 37.6418 2.4101C38.4292 2.69702 38.4851 2.86425 38.6177 3.38295L40.0625 9.0071H41.9993L44.9829 1.8048H43.0507L41.1335 6.70167L40.3512 2.55069C40.2795 2.07564 39.916 1.80457 39.4713 1.80457H36.3909L36.3907 1.8048ZM45.76 1.8048L44.2443 9.0071H46.0869L47.5972 1.8048H45.76ZM56.0368 1.8048C55.5925 1.8048 55.357 2.04508 55.1844 2.46478L52.4848 9.0071H54.4171L54.7908 7.91664H57.1448L57.3721 9.0071H59.0771L57.5898 1.8048H56.0368ZM56.2881 3.75073L56.8609 6.45334H55.3266L56.2883 3.75073H56.2881Z"
          fill="#1434CB"
        />
      </g>
      <g clipPath="url(#clip2_80_1273)">
        <path d="M77.8962 1.40039H73.4258V9.41427H77.8962V1.40039Z" fill="#FF5F00" />
        <path
          d="M73.7095 5.40763C73.7088 4.63583 73.8841 3.87399 74.2222 3.17978C74.5603 2.48557 75.0523 1.87719 75.6609 1.40069C74.9072 0.809715 74.002 0.442199 73.0488 0.340143C72.0957 0.238088 71.1329 0.405608 70.2707 0.823565C69.4084 1.24152 68.6815 1.89305 68.1729 2.70367C67.6642 3.5143 67.3945 4.45132 67.3945 5.40763C67.3945 6.36394 67.6642 7.30095 68.1729 8.11158C68.6815 8.9222 69.4084 9.57373 70.2707 9.99169C71.1329 10.4096 72.0957 10.5772 73.0488 10.4751C74.002 10.3731 74.9072 10.0055 75.6609 9.41456C75.0523 8.93806 74.5603 8.32967 74.2222 7.63547C73.8841 6.94126 73.7088 6.17942 73.7095 5.40763Z"
          fill="#EB001B"
        />
        <path
          d="M83.9282 5.40763C83.9283 6.36392 83.6586 7.30093 83.15 8.11156C82.6414 8.92218 81.9145 9.57371 81.0522 9.99167C80.19 10.4096 79.2273 10.5772 78.2741 10.4751C77.3209 10.3731 76.4158 10.0055 75.6621 9.41456C76.2702 8.93758 76.7618 8.3291 77.0998 7.635C77.4378 6.9409 77.6135 6.1793 77.6135 5.40763C77.6135 4.63595 77.4378 3.87435 77.0998 3.18025C76.7618 2.48615 76.2702 1.87767 75.6621 1.40069C76.4158 0.809713 77.3209 0.442196 78.2741 0.340142C79.2273 0.238088 80.19 0.405616 81.0522 0.823577C81.9145 1.24154 82.6414 1.89307 83.15 2.70369C83.6586 3.51432 83.9283 4.45133 83.9282 5.40763Z"
          fill="#F79E1B"
        />
        <path
          d="M83.4405 8.5655V8.40143H83.5068V8.368H83.3379V8.40143H83.4042V8.5655H83.4405ZM83.7684 8.5655V8.36768H83.7166L83.6571 8.50374L83.5975 8.36768H83.5457V8.5655H83.5822V8.41628L83.6381 8.54493H83.676L83.7318 8.41595V8.5655H83.7684Z"
          fill="#F79E1B"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_80_1273"
          x1="27.3004"
          y1="1.19292"
          x2="21.7608"
          y2="1.19292"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1F5CD7" />
          <stop offset="1" stopColor="#02AEFF" />
        </linearGradient>
        <clipPath id="clip0_80_1273">
          <rect
            width="24.5818"
            height="7.02336"
            fill="white"
            transform="translate(3.75781 1.89551)"
          />
        </clipPath>
        <clipPath id="clip1_80_1273">
          <rect
            width="22.7482"
            height="7.45844"
            fill="white"
            transform="translate(36.3398 1.67822)"
          />
        </clipPath>
        <clipPath id="clip2_80_1273">
          <rect width="17.1544" height="10.8147" fill="white" transform="translate(67.0879)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function MirLogo({ style, className, width, height }: LogoProps) {
  return (
    <svg
      width={width ?? designTokens.sizes.width.paymentMethodLogoMir}
      height={height ?? designTokens.sizes.height.paymentMethodLogoMir}
      viewBox="0 0 24.5818 7.02336"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <g clipPath="url(#clip0_mir)">
        <path
          d="M0.0683594 0.210571H2.35343C2.56116 0.210571 3.18436 0.140333 3.46134 1.12361C3.66907 1.75571 3.94605 2.73899 4.36152 4.21388H4.5C4.91547 2.66874 5.26169 1.61524 5.40018 1.12361C5.67716 0.140333 6.3696 0.210571 6.64658 0.210571H8.7932V6.953H6.57734V2.94968H6.43885L5.26169 6.953H3.59983L2.42267 2.94968H2.21494V6.953H0.0683594M9.6933 0.210571H11.9092V4.21388H12.1169L13.571 0.912906C13.848 0.280806 14.4712 0.210571 14.4712 0.210571H16.5485V6.953H14.3326V2.94968H14.1942L12.7401 6.25066C12.4631 6.88276 11.7707 6.953 11.7707 6.953H9.6933M19.5261 4.91622V6.953H17.4488V3.44132H24.2348C23.9578 4.28412 22.9883 4.91622 21.8804 4.91622"
          fill="#0F754E"
        />
        <path
          d="M24.3735 3.01979C24.6505 1.75559 23.8196 0.210449 22.0193 0.210449H17.3107C17.4491 1.68535 18.6954 3.01979 20.0111 3.01979"
          fill="url(#paint0_mir)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_mir"
          x1="23.5427"
          y1="-0.702591"
          x2="18.0031"
          y2="-0.702591"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1F5CD7" />
          <stop offset="1" stopColor="#02AEFF" />
        </linearGradient>
        <clipPath id="clip0_mir">
          <rect width="24.5818" height="7.02336" fill="white" transform="translate(0 0)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function DolamiLogo({ style, className, width, height }: LogoProps) {
  return (
    <svg
      width={width ?? designTokens.sizes.width.paymentMethodLogoDolami}
      height={height ?? designTokens.sizes.height.paymentMethodLogoDolami}
      viewBox="0 0 66 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <g clipPath="url(#clip0_80_1225)">
        <path
          d="M11.655 1.7749H10.0899V9.71239H11.655V1.7749ZM8.29188 2.21894H6.7268V10.1564H8.29188V2.21894ZM4.92875 2.7151H3.36314V10.6536H4.92875V2.7151ZM1.56509 3.21647H0V11.156H1.56509V3.21647ZM52.9967 6.00371L50.4763 3.20188H49.0029V9.68946H50.5414V5.55029L52.8424 8.00294H53.1264L55.3878 5.55029V9.68946H56.9263V3.20188H55.453L52.9967 6.00371ZM64.2551 3.20188L60.4422 7.41818V3.20188H58.9037V9.68946H60.3134L64.1263 5.47316V9.68946H65.6643V3.20188H64.2551ZM40.7167 5.57583C40.7167 6.60879 41.2817 7.42235 42.1489 7.76372L40.5229 9.68946H42.4059L43.885 7.93727H45.485V9.68946H47.024V3.20188H43.1074C41.647 3.20188 40.7167 4.20045 40.7167 5.57583ZM45.4865 4.63042V6.54938H43.3925C42.6941 6.54938 42.3188 6.15954 42.3188 5.58886C42.3188 5.01817 42.7071 4.62885 43.3925 4.62885L45.4865 4.63042ZM33.5683 4.49908C33.4745 6.73075 33.0034 8.17075 32.0819 8.17075H31.851V9.72854L32.097 9.74157C33.9451 9.84477 34.9661 8.22287 35.1339 4.68097H37.5647V9.68946H39.1006V3.20188H33.6194L33.5683 4.49908ZM27.7776 3.11119C25.697 3.11119 24.1997 4.5512 24.1997 6.44515C24.1997 8.40476 25.8289 9.79369 27.7776 9.79369C29.807 9.79369 31.3841 8.32711 31.3841 6.44515C31.3841 4.56319 29.807 3.11119 27.7776 3.11119ZM27.7776 8.23642C26.6013 8.23642 25.8002 7.4703 25.8002 6.44515C25.8002 5.39446 26.6028 4.6497 27.7776 4.6497C28.9523 4.6497 29.7809 5.42833 29.7809 6.44515C29.7809 7.46196 28.9413 8.23642 27.7776 8.23642ZM22.5684 3.21386H17.1388L17.0867 4.51159C17.0101 6.38104 16.5223 8.15877 15.6008 8.1843L15.174 8.19733V11.156L16.7255 11.1529V9.6905H22.1155V11.1529H23.6801V8.1843H22.5684V3.21386ZM21.0299 8.1843H17.747C18.3026 7.34104 18.6002 6.12098 18.6518 4.694H21.0299V8.1843Z"
          fill={designTokens.colors.text.black}
        />
      </g>
      <defs>
        <clipPath id="clip0_80_1225">
          <rect width="65.668" height="13.3111" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
